<div class="warning-banner">
  <div class="pending-label" i18n>
    Updates pending. The information in this section does not reflect any change requests.
  </div>
  <div i18n>Further edits to Address will not be allowed during this time.</div>
  <div class="pt-1" i18n>
    You can view the requested changes
    <button (click)="viewSubmission.emit()" type="button" class="link-button no-style-button">here.</button>
  </div>
</div>
